import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FormControl, FormHelperText, FormLabel } from '@material-ui/core';

const StyledFormElement = styled.article`
  display: flex;
  align-items: center;
  margin: 0.5rem 0;

  .MuiFormControl-root {
    display: flex;
    flex: 1;
    margin-bottom: 1rem;

    &.MuiTextField-root {
      flex: 1;
    }

    legend {
      position: absolute;
      top: -5px;
      left: 10px;
      padding: 0 0.5rem;
      margin-bottom: 0.5rem;
      color: var(--grey);
      font-size: 1.2rem;
      background: white;
      z-index: 10;
    }
  }
`;

export const FormElement = ({
  label, icon, required, helperText, error, children, ...props
}) => (
  <StyledFormElement {...props}>
    <FormControl component="fieldset" error={error} required={required}>
      {label && (
        <FormLabel component="legend">
          {label}
          {icon}
        </FormLabel>
      )}
      {children}
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  </StyledFormElement>
);

FormElement.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  icon: PropTypes.element,
  label: PropTypes.string,
  required: PropTypes.bool
};

FormElement.defaultProps = {
  error: null,
  helperText: '',
  icon: null,
  label: '',
  required: false
};